import { OrderOrganizerAction } from "./order-organizer-action";
import { OrderOrganizer } from "src/app/shared/models/order-organizer.model";

export class OrderOrganizerEditAction extends OrderOrganizerAction{
  constructor(organizer: OrderOrganizer, action: (OrderOrganizer) => void) {
    super("Edit", false, organizer, action);
  }
}
